import {Query, Predicate} from 'olympe';
import ColumnsDataType from '../models/adminApp/ColumnsDataType';
import UniqueIndex from '../models/adminApp/UniqueIndex';

/**
 * Singleton class that control purchase requests.
 */
export class ColumnsDataTypeController {
    /**
     * @param {string} selectedTable
     * @return {Array<object>}
     */
    static async getFilteredColumns(selectedTable) {
        const cloudObj = await Query.instancesOf(ColumnsDataType)
            .filter(Predicate.equals(ColumnsDataType.tableNameProp, selectedTable)).execute();
        const result = cloudObj.toArray();
        return result.map((col) => {
            return {
                column: col.getColumnName(),
                type: col.getType(),
                width: col.getWidth(),
                columnDisplayName: col.getColumnDisplayName(),
            };
        });
    }

    /**
     * @param {BrickContext} context
     * @param {string} selectedTable
     * @return {string}
     */
    static async getPrimaryKeysColumn(context, selectedTable) {
        const cloudObj = await Query.instancesOf(UniqueIndex)
            .filter(Predicate.equals(UniqueIndex.tableNameProp, selectedTable)).execute();
        const result = cloudObj.getFirst();
        return result.getColumnName();
    }
};
